import { createAsyncThunk } from "@reduxjs/toolkit";
import { client } from "../../utils/api";

export const fetchStore = createAsyncThunk(
  "store/fetch",
  async (_, { signal, rejectWithValue }) => {
    try {
      const store = await client("store/store", { signal });
      if (!store || typeof store.name !== "string") {
        throw new Error("Invalid store response");
      }
      return store;
    } catch (error) {
      return rejectWithValue({
        notFound:
          error?.response?.status === 400 &&
          error?.json?.detail === "Invalid Store",
      });
    }
  }
);
